import { CollectdataService } from './../services/collectdata.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Chart} from 'node_modules/chart.js';

@Component({
  selector: 'app-countrywise',
  templateUrl: './countrywise.component.html',
  styleUrls: ['./countrywise.component.css']
})
export class CountrywiseComponent implements OnInit {
  id: string;
  data: any[];
  idData;
  constructor(public activatedRoute: ActivatedRoute, public collectData: CollectdataService) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.collectData.getData().subscribe( (data) => {
      this.data = data;
      this.assignCountry();
      this.createChart();
    });

  }
  assignCountry(){
    this.data.forEach((element) => {
      if (element.country === this.id){
        this.idData = element;
      }
    });
    // console.log(this.idData.active);

  }
  ngOnInit(): void {
  }
  createChart(){
    var myDoughnutChart = new Chart('mychart', {
      type: 'pie',
      data: {
        labels: ['Confirmed', 'Active', 'Recovered', 'Deaths'],
        datasets: [{
            data: [this.idData.cases, this.idData.active, this.idData.recovered, this.idData.deaths],
            backgroundColor: [
                'rgba(255, 0, 0, 0.8)',
                'rgba(255, 108, 0, 0.8)',
                'rgba(77, 255, 0, 0.8)',
                'rgba(58, 51, 59, 0.8)',
            ],
            // borderColor: [
            //   'rgba(255, 0, 0, 0.9)',
            //   'rgba(255, 108, 0, 0.9)',
            //   'rgba(77, 255, 0, 0.9)',
            //   'rgba(58, 51, 59, 0.9)',
            // ],
            borderWidth: 0.5
        }],
        options: {responsive : true,
          aspectRatio: 1,

        },
      },

      });
    }

}
